import * as ActionTypes from "constants/ActionTypes";

export const receivedUserInteraction = () => ({
  type: ActionTypes.RECEIVED_USER_INTERACTION,
});

export const userInteractionInitiatedPlayback = () => ({
  type: ActionTypes.USER_INTERACTION_INITIATED_PLAYBACK,
});

export function userReportedStoryAbuse(storyId) {
  return {
    type: ActionTypes.USER_INTERACTION_REPORT_ABUSE,
    storyId,
  };
}

export function userSharedStory(shareType) {
  return {
    type: ActionTypes.USER_SHARED_STORY,
    shareType,
  };
}
